/* eslint-disable ember/no-classic-components */
import Component from "@ember/component";
import { computed } from "@ember/object";
import { tagName } from "@ember-decorators/component";
import CategoryTitleLink from "discourse/components/category-title-link";
import { arraySortedByProperties } from "discourse/lib/array-tools";
import { slugify } from "discourse/lib/utilities";
import Category from "discourse/models/category";
import dConcatClass from "discourse/ui-kit/helpers/d-concat-class";
import dDiscourseTag from "discourse/ui-kit/helpers/d-discourse-tag";
import dIcon from "discourse/ui-kit/helpers/d-icon";
import { i18n } from "discourse-i18n";

@tagName("")
export default class TagList extends Component {
  isPrivateMessage = false;

  @computed("tags", "sortProperties")
  get sortedTags() {
    return arraySortedByProperties(this.tags, this.sortProperties);
  }

  @computed("titleKey")
  get title() {
    return this.titleKey && i18n(this.titleKey);
  }

  @computed("categoryId")
  get category() {
    return this.categoryId && Category.findById(this.categoryId);
  }

  @computed("category.fullSlug")
  get categoryClass() {
    return this.category?.fullSlug && `tag-list-${this.category?.fullSlug}`;
  }

  @computed("tagGroupName")
  get tagGroupNameSlug() {
    if (this.tagGroupName) {
      return slugify(this.tagGroupName);
    }
  }

  @computed("tagGroupNameSlug")
  get tagGroupNameClass() {
    return this.tagGroupNameSlug && `tag-group-${this.tagGroupNameSlug}`;
  }

  <template>
    <div
      class={{dConcatClass
        "tags-list"
        "tag-list"
        this.categoryClass
        this.tagGroupNameClass
      }}
      ...attributes
    >
      {{#if this.title}}
        <h3>{{this.title}}</h3>
      {{/if}}
      {{#if this.category}}
        <CategoryTitleLink @category={{this.category}} />
      {{/if}}
      {{#if this.tagGroupName}}
        <h3 id={{this.tagGroupNameSlug}}><a
            aria-label={{i18n "post.heading_anchor"}}
            class="anchor"
            href="#{{this.tagGroupNameSlug}}"
          ></a>{{this.tagGroupName}}</h3>
      {{/if}}
      {{#each this.sortedTags as |tag|}}
        <div class="tag-box">
          {{dDiscourseTag
            tag
            description=tag.description
            isPrivateMessage=this.isPrivateMessage
            pmOnly=tag.pmOnly
            tagsForUser=this.tagsForUser
          }}
          {{#if tag.pmOnly}}
            {{dIcon "envelope"}}
          {{/if}}
          {{#if tag.totalCount}}
            <span class="tag-count">
              x
              {{tag.totalCount}}
            </span>
          {{/if}}
        </div>
      {{/each}}
      <div class="clearfix"></div>
    </div>
  </template>
}
